import React from 'react';
import CustomContentLoader from '../ContentLoader/ContentLoader';
import contentLoaderConfig from '../ContentLoader/ContentLoaderConfig';

import './RepliesLoadingAnimation.css';
import useWidthMeasurement from '../../hooks/useWidthMeasurement';

const RepliesLoadingAnimation = () => {
  const windowType = useWidthMeasurement();
  return (
    <div styleName="replies-loader-wrapper">
      <CustomContentLoader config={contentLoaderConfig[windowType]} />
    </div>
  );
};

export default RepliesLoadingAnimation;
